import "../sentryInstrumentReact";
import React from 'react';
import ReactDOM from 'react-dom/client';

import AddToCart from "./AddToCart";

const addToCartDiv = document.getElementById('add-to-cart');
if (addToCartDiv !== null) {
  const cleanProductId = parseInt(addToCartDiv.dataset.productId.replace(/,/g, ''), 10);
  const selectDiv = ReactDOM.createRoot(addToCartDiv);
  selectDiv.render(
    <>
      <AddToCart productId={cleanProductId} />
    </>
  );  
}